export const menuItems = [
    {
        id: 1,
        label: 'menuitems.dashboards.text',
        icon: 'bx-home-circle',
        subItems: [
            {
                id: 2,
                label: 'menuitems.dashboards.list.default',
                link: '/',
                parentId: 1
            },
            {
                id: 3,
                label: 'menuitems.dashboards.list.atendimento',
                link: '/dashboard/saas',
                parentId: 1
            },
            {
                id: 4,
                label: 'menuitems.dashboards.list.analitico',
                link: '/dashboard/crypto',
                parentId: 1
            },
            {
                id: 5,
                label: 'menuitems.dashboards.list.supervisao',
                link: '/dashboard/blog',
                parentId: 1
            },
        ]
    },

    {
        id: 7,
        label: "menuitems.orcamentos.text",
        icon: "bx-rocket",
        subItems: [
            {
                id: 8,
                label: "menuitems.orcamentos.list.listar",
                link: "/orcamentos/list",
                parentId: 7
            },
            {
                id: 9,
                label: "menuitems.orcamentos.list.addnovo",
                link: "/orcamento/detalhe/1",
                parentId: 7
            }
        ]
    },

    {
        id: 10,
        label: "menuitems.pedidos.text",
        icon: "bx-cart",
        subItems: [
            {
                id: 11,
                label: "menuitems.pedidos.list.listar",
                link: "/pedidos/list",
                parentId: 10
            },
            {
                id: 12,
                label: "menuitems.pedidos.list.detalhes",
                link: "/pedido/detalhe/1",
                parentId: 10
            }
        ]
    },

    {
        id: 13,
        label: "menuitems.clientes.text",
        icon: "bx bxs-user-detail",
        subItems: [
            {
                id: 14,
                label: "menuitems.clientes.list.listar",
                link: "/clientes/list",
                parentId: 13
            },
            {
                id: 15,
                label: "menuitems.clientes.list.detalhes",
                link: "/cliente/detalhe/1",
                parentId: 13
            }
        ]
    },

    {
        id: 21,
        label: "menuitems.calendar.text",
        icon: "bx-calendar",
        link: "/calendario"
    },

    {
        id: 23,
        label: "menuitems.produtos.text",
        icon: "bx bxs-dashboard",
        subItems: [
            {
                id: 24,
                label: "menuitems.produtos.list.listar",
                link: "/produtos/list",
                parentId: 23
            },
            {
                id: 25,
                label: "menuitems.produtos.list.detalhes",
                link: "/produto/detalhe/1",
                parentId: 23
            }
        ]
    },

    {
        id: 26,
        label: "menuitems.cadastros.text",
        icon: "bx-receipt",
        subItems: [
            {
                id: 27,
                label: "menuitems.cadastros.list.condicoes",
                link: "/condicoes/list",
                parentId: 26
            },
            {
                id: 28,
                label: "menuitems.cadastros.list.formas",
                link: "/formas/list",
                parentId: 26
            },
            {
                id: 29,
                label: "menuitems.cadastros.list.pedtipo",
                link: "/tiposopera/list",
                parentId: 26
            },
            {
                id: 30,
                label: "menuitems.cadastros.list.representantes",
                link: "/repres/list",
                parentId: 26
            }
        ]
    },


];

